import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, ChevronDown, X } from 'lucide-react';

function Header() {
  const [isToolsOpen, setIsToolsOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toolsLinks = [
    { name: 'PDF Chat Assistant', url: 'https://pdf-rag-app.example.com' },
    { name: 'Document Q&A Bot', url: 'https://doc-qa.example.com' },
    { name: 'Smart Knowledge Base', url: 'https://knowledge-base.example.com' },
    { name: 'AI Research Helper', url: 'https://research-ai.example.com' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-slate-950/95 backdrop-blur-lg border-b border-slate-800 shadow-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">

          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="relative">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-500 rounded-lg flex items-center justify-center shadow-lg shadow-purple-900/50 group-hover:shadow-purple-900/80 transition-all">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full border-2 border-slate-950 animate-pulse"></div>
            </div>
            <span className="font-bold text-xl bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 text-transparent bg-clip-text">
              Resume AI
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">

            {/* Tools Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsToolsOpen(!isToolsOpen)}
                onMouseEnter={() => setIsToolsOpen(true)}
                className="flex items-center space-x-1 text-slate-200 hover:text-white transition-colors font-semibold text-base"
              >
                <span>Tools</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isToolsOpen ? 'rotate-180' : ''}`} />
              </button>

              {/* Dropdown Menu */}
              {isToolsOpen && (
                <div
                  onMouseLeave={() => setIsToolsOpen(false)}
                  className="absolute top-full left-0 mt-2 w-56 bg-slate-900 border border-slate-700 rounded-xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200 z-50"
                >
                  {toolsLinks.map((tool, index) => (
                    <a
                      key={index}
                      href={tool.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-3 text-sm text-slate-300 hover:bg-slate-800 hover:text-white transition-colors border-b border-slate-800 last:border-b-0"
                    >
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-purple-500 rounded-full mr-3"></div>
                        {tool.name}
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* About Link */}
            <Link
              to="/about"
              className="text-slate-200 hover:text-white transition-colors font-semibold text-base"
            >
              About
            </Link>

          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-slate-300 hover:text-white transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-800 animate-in slide-in-from-top duration-200">

            {/* Tools Section */}
            <div className="mb-4">
              <button
                onClick={() => setIsToolsOpen(!isToolsOpen)}
                className="flex items-center justify-between w-full px-4 py-2 text-slate-300 hover:text-white transition-colors font-medium"
              >
                <span>Tools</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isToolsOpen ? 'rotate-180' : ''}`} />
              </button>

              {isToolsOpen && (
                <div className="mt-2 space-y-1 pl-6">
                  {toolsLinks.map((tool, index) => (
                    <a
                      key={index}
                      href={tool.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block px-4 py-2 text-sm text-slate-400 hover:text-white transition-colors"
                    >
                      {tool.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            {/* About Link */}
            <Link
              to="/about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block px-4 py-2 text-slate-300 hover:text-white transition-colors font-medium"
            >
              About
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
